'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { Checkbox } from '@/ui/form/inputs/checkbox/Checkbox.client'
import { Row as AriaRow, Collection, useTableOptions, type RowProps } from 'react-aria-components'
import { Cell } from './Cell.client'

export function Row<T extends object>({ id, columns, children, className, ...props }: RowProps<T>) {
  const { selectionBehavior } = useTableOptions()

  return (
    <AriaRow
      id={id}
      {...props}
      className={twMerge('border-b-px border-brand-2-200 last:border-b-0', className)}
    >
      {selectionBehavior === 'toggle' && (
        <Cell>
          <Checkbox slot="selection" />
        </Cell>
      )}

      <Collection items={columns}>{children}</Collection>
    </AriaRow>
  )
}
